export default __webpack_public_path__ + "static/media/aroma6.914ad8b4.png";